import { createFileRoute } from '@tanstack/react-router';
import { StudentHomeDashboardPage } from '@pages/student';

/**
 * Student Dashboard Page
 *
 * Route: /:locale/student/
 */
export const Route = createFileRoute('/$locale/_authenticated/student/')({
  component: StudentDashboard,
});

export function StudentDashboard() {
  return <StudentHomeDashboardPage />;
}
